module.exports = __webpack_public_path__ + "img/Intranet_Head2.1b1c53a3.png";